import { GuidedTour, Orientation } from "ngx-guided-tour";

export const welcomeHomeTour: GuidedTour = {
    tourId: 'welcomeHome',
    useOrb: false,
    steps: [
        {
            title: '  ',
            content: `
                <img src="assets/undraw/celebration.svg" class="w-75 undraw d-flex mx-auto">
                <p class="text-center mt-3">Pronto! <strong>Você já pode começar a utilizar o Estudei</strong> nos seus estudos!</p>
                <p class="text-center mt-3">Mas, antes, quero te mostrar algumas funcionalidades importantes para você aproveitá-lo ao máximo. <strong>Bora lá?</strong></p>
            `
        },
        {
            title: 'Home',
            selector: '.logo',
            content: 'Esta é sua <strong>Home</strong>. Aqui, você terá um resumo dos seus estudos e poderá acompanhar toda sua evolução.',
            orientation: Orientation.Right,
            highlightPadding: 10,
            closeAction: () => {
                const page = document.getElementById('page');
                if (page) page.scrollTo({ top: 550 });
            }
        },
        {
            title: 'Home',
            selector: '.planning',
            content: 'O Estudei pode te ajudar com seu <strong>Planejamento</strong>, criando um ciclo de estudos automático e personalizado.<br /><br />Se preferir, você também pode adicionar seu próprio planejamento à plataforma e acompanhá-lo por aqui.',
            orientation: Orientation.Top,
            highlightPadding: 15
        },
        {
            title: 'Estudos',
            selector: '.line-buttons>button',
            content: 'Para <strong>registrar os seus estudos diários</strong>, você pode clicar diretamente aqui.',
            orientation: Orientation.BottomRight,
            highlightPadding: 10
        },
        {
            title: 'Estudos',
            selector: '.hidden',
            content: 'Ou você pode utilizar nosso <strong>cronômetro</strong> para computar seu tempo de estudos.',
            orientation: Orientation.TopRight,
            highlightPadding: 10
        },
        {
            title: 'Barra Lateral',
            selector: '.sidebar',
            content: 'Aqui na <strong>Barra Lateral</strong> você consegue acessar as demais páginas do Estudei!',
            orientation: Orientation.Right,
            highlightPadding: 0
        },
        {
            title: 'Barra Lateral',
            selector: '.menu>.item:nth-child(4)',
            content: 'Ah, aproveitando, <strong>se você já estudou algum dos tópicos</strong> do seu plano, pode marcá-los como concluídos aqui, no seu <strong>Edital Verticalizado</strong>.',
            orientation: Orientation.Right,
            highlightPadding: 10
        }
    ]
};